export default {
    PENDING: {
        value: 'pending',
        label: '未开始',
    },
    ONGOING: {
        value: 'ongoing',
        label: '进行中',
    },
    COMPLETE: {
        value: 'complete',
        label: '已结束',
    }
}


export const BANNER_LOCATION = Object.freeze({
    home: 'home',
    video_home: 'video_home',
    credit_shop: 'credit_shop',

    options() {
        return [
            {label: '首页', value: this.home},
            {label: '视频首页', value: this.video_home},
            {label: '积分商城', value: this.credit_shop},
        ]
    },

    filterValue(value) {
        return this.options().find(op => op.value === value)?.label
    }
})
